<template>
    <div>
        <ul class="navbar-nav mt-4 mb-4">
            <li class="nav-item">
                <router-link :to="`/${siteSlug}`" class="link">
                    <button class="btn menu-btn-home btn-block" type="submit">{{ $t("Home") }}</button>
                </router-link>
            </li>
        </ul>

        <ul :key="menu.id" class="navbar-nav mt-4" v-for="menu in menus">
            <li class="nav-item">
                <router-link :to="`/${siteSlug}/${menu.type}`" class="link">
                    <button :class="`btn btn-${menu.type}-menu btn-block text-truncate`">
                        {{ menu.type | ucFirst }} {{ $t("menu") }}
                    </button>
                </router-link>
            </li>

            <li :key="section.id" class="nav-item" v-for="section in menu.sections">
                <router-link :to="`/${siteSlug}/${menu.type}?section_id=${section.id}`" class="link">
                    <button :class="`btn menu-item-${menu.type} btn-block text-truncate`">
                        {{ section.menu_category.name }}
                    </button>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['siteSlug', 'menus']
}
</script>